export function getCenterDate(v0: Date, v1?: Date) {
  return v1 ? (v0.getTime() + v1?.getTime()) / 2 : v0.getTime();
}
